var map = {
	"./decidim/avatar-multiuser.png": 88038,
	"./decidim/brands/facebook.svg": 91856,
	"./decidim/brands/google.svg": 77641,
	"./decidim/brands/twitter-x.svg": 58562,
	"./decidim/cc-badge.png": 60568,
	"./decidim/decidim-logo.svg": 81828,
	"./decidim/default-avatar.svg": 13052,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 12616,
	"./decidim/icons.svg": 22775,
	"./decidim/pattern.png": 26840,
	"./decidim/placeholder-card-g.svg": 48893,
	"./decidim/placeholder-card-l.svg": 97206,
	"./decidim/placeholder.jpg": 58165,
	"./decidim/remixicon.symbol.svg": 4473,
	"./decidim/vendor/social-share-button/douban.svg": 91288,
	"./decidim/vendor/social-share-button/email.svg": 2581,
	"./decidim/vendor/social-share-button/facebook.svg": 25003,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 46021,
	"./decidim/vendor/social-share-button/hacker_news.svg": 78725,
	"./decidim/vendor/social-share-button/linkedin.svg": 68173,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 97822,
	"./decidim/vendor/social-share-button/pinterest.svg": 97099,
	"./decidim/vendor/social-share-button/reddit.svg": 24255,
	"./decidim/vendor/social-share-button/telegram.svg": 50098,
	"./decidim/vendor/social-share-button/tumblr.svg": 1937,
	"./decidim/vendor/social-share-button/twitter.svg": 35332,
	"./decidim/vendor/social-share-button/vkontakte.svg": 80794,
	"./decidim/vendor/social-share-button/wechat.svg": 68229,
	"./decidim/vendor/social-share-button/whatsapp.svg": 74549,
	"./decidim/vendor/social-share-button/x.svg": 13397,
	"./decidim/vendor/social-share-button/xing.svg": 63179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49271;